import { render, staticRenderFns } from "./HintsInfo.vue?vue&type=template&id=6d8312f5"
import script from "./HintsInfo.vue?vue&type=script&lang=js"
export * from "./HintsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports